<template>
  <!-- {{ $route.query.vmLink }} -->
  <post-form
    v-if="$msal.accounts[0] && $route.query.vmLink"
    @emitRefs="(button) => (submitBtn = button)"
    :action="$route.query.vmLink"
    :nameIdentifier="$msal.accounts[0].localAccountId"
    :cmd="'login'"
  />
</template>

<script>
import PostForm from "@/components/PostForm.vue";
export default {
  components: { PostForm },
  data() {
    return {
      submitBtn: null,
    };
  },
  mounted() {
    const vmLink = this.$route.query.vmLink;
    if (this.$msal.accounts[0] && vmLink) {
      this.submitBtn.click();
    } else {
      this.$router.replace("/");
    }
  },
};
</script>

<style>
</style>